import { observer } from 'mobx-react';

// Hooks
import { useStores } from 'hooks/use-stores';
import useQuery from 'hooks/use-query';

// Components
import CartItemAddModal from './CartItemAddModal';
import CartItemModalContainer from './CartItemModalContainer';

const CartItemAddModalContainer = () => (
  <CartItemModalContainer getCartItemFromQueryParams={getCartItemFromQueryParams}>
    <CartItemAddModal />
  </CartItemModalContainer>
);

const getCartItemFromQueryParams = () => {
  const { menuDataStore, checkoutStore, userStore } = useStores();
  const { selectedMenu } = menuDataStore;
  const { selectedCart } = checkoutStore;
  const { anonymousUserId } = userStore;
  const query = useQuery();
  const itemId = query.get('item');
  const menuId = query.get('menu');

  if (!itemId || !menuId || !selectedMenu || !selectedCart || !anonymousUserId) {
    return undefined;
  }

  const cartItem = selectedCart?.isSharedCart
    ? selectedCart.sharedCartReference?.createSharedCartItem(menuId, itemId, anonymousUserId)
    : selectedCart.createCartItem(selectedMenu.customer_id, menuId, itemId);

  return cartItem?.menuItem ? cartItem : undefined;
};

export default observer(CartItemAddModalContainer);
